import React, { useMemo } from "react";
import "./FlowerTurf.css";
import { buildFlowerField } from "./flowerScatter";
import FlowerField from "./FlowerField";

/**
 * FlowerTurf — the wildflower meadow the catalogue sits in, drawn as scattered
 * cut-paper flowers that keep CLEAR of the path instead of being cut by it.
 *
 * This replaces the old grass turf. The scatter + path-clearance logic lives in
 * flowerScatter.js (pure, unit-tested); this component just sizes the <svg> and
 * renders the shared FlowerField body. Memoized: the host grid re-renders often
 * while `geometry` keeps a stable identity until the measured layout actually
 * changes (see useTrailGeometry).
 */
function FlowerTurf({ geometry }) {
  const field = useMemo(() => (geometry ? buildFlowerField(geometry) : null), [geometry]);
  if (!geometry || !field) return null;

  const { x0, y0, vw, vh, templates, layers } = field;
  return (
    <svg
      className="flower-turf"
      width={vw}
      height={vh}
      viewBox={`${x0} ${y0} ${vw} ${vh}`}
      style={{ left: `${x0}px`, top: `${y0}px` }}
      aria-hidden="true"
    >
      <FlowerField templates={templates} layers={layers} idPrefix="flower" />
    </svg>
  );
}

export default React.memo(FlowerTurf);
